import styled from 'styled-components';
import { validateRightControlPanelAction, doRightControlPanelAction } from './utils';
import useViewState from './useViewState';
import DrawerButton from './base/DrawerButton';
import ActionsDrawer from './ActionsDrawer';
import { withColorSchemeInfoStyled } from '../../redux/prefs/access';

/**
 * @todo Remove this call to withColorSchemeInfoStyled when we can figure out how to ensure
 * that the internal DrawerButton gets the $colorSchemeInfo
 */
const ToggleButton = withColorSchemeInfoStyled(styled(DrawerButton)`
    color: ${({ $checked }) => ($checked ? 'rgb(67, 242, 88)' : 'rgb(133, 145, 135)') }
`);

// NOTE: Previous implementation of toggle buttons can accommodate more two states.
// However, this feature was not used so the logic below was simplied to accommodate
// only two states (ie. on/off)
export default function TogglesDrawer({
    toggles, ...props
}) {
    const updates = useViewState();
    const toggleButtons = toggles.map((tog) => (
        <ToggleButton
            key={tog.id}
            title={tog.desc}
            onClick={handleClick(tog.id, updates[tog.id])}
            $checked={updates[tog.id]}
        >
            {tog.label}
        </ToggleButton>
    ));

    function handleClick(id, checked) {
        return () => {
            // NOTE: When user clicks toggle button, the checked state will be inverted. So if
            // the current checked state is true, then next state should be false ('off').
            const styleId = `${id}${checked ? 'off' : 'on'}`;

            if (validateRightControlPanelAction(styleId)) {
                doRightControlPanelAction(styleId);
            }
        };
    }

    return <ActionsDrawer {...props}>{toggleButtons}</ActionsDrawer>;
}
